import React from 'react';
import './AvatarPreviewImage.css';

interface AvatarPreviewImage {
  thumbnails: string[];
  onSelect: (imageUrl: string) => void;
}

const AvatarPreviewImage: React.FC<AvatarPreviewImage> = ({ thumbnails, onSelect }) => {
  return (
    <div className="thumbnailsAvatar-container">
      {thumbnails.map((thumbnail, index) => (
        <div key={index} className="thumbnailsAvatar-wrapper">
          <img
            src={thumbnail}
            alt={`Thumbnail ${index}`}
            onClick={() => onSelect(thumbnail)}
            className="thumbnail"
          />
        </div>
      ))}
    </div>
  );
};

export default AvatarPreviewImage;
